'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { MenuItem } from '@/fo/ui/app/menu/base';

import {
  ContactInfo,
  FirstScreen
} from '../components/FirstScreen/FirstScreen';
import {
  NavigationLevel,
  NestedScreen
} from '../components/NestedScreen/NestedScreen';

import { styles } from './UiAppMenuMobile.styles';

export interface UiAppMenuMobileProps {
  className?: string;
  city?: string;
  items?: MenuItem[];
  additionalItems?: MenuItem[];
  infoItems?: MenuItem[];
  contactInfo?: ContactInfo;
  searchInput?: React.ReactNode;
  searchSuggestion?: React.ReactNode;
}

export function UiAppMenuMobile({
  className,
  city,
  items = [],
  additionalItems = [],
  infoItems = [],
  contactInfo,
  searchInput,
  searchSuggestion
}: UiAppMenuMobileProps) {
  const slots = styles();

  const t = useTranslations();

  const [showSearch, setShowSearch] = useState(false);
  const [navigation, setNavigation] = useState<NavigationLevel[]>([]);

  const handleMenuItemClick = (
    items: MenuItem[],
    index: number,
    title: string
  ) => {
    const selectedItem = items[index];
    if (
      selectedItem &&
      selectedItem.children &&
      selectedItem.children.length > 0
    ) {
      setNavigation((prev) => [...prev, { items, index, title }]);
    }
  };

  const handleBackClick = () => {
    setNavigation((prev) => prev.slice(0, -1));
  };

  if (showSearch) {
    return (
      <div className={slots.base({ className })}>
        <div
          className={slots.closeButton()}
          onClick={() => setShowSearch(false)}
        >
          <ArrowIcon className={slots.closeButtonIcon()} />
          {t('menu')}
        </div>
        {searchSuggestion}
      </div>
    );
  }

  return (
    <div className={slots.base({ className })}>
      {navigation.length === 0 ? (
        <FirstScreen
          searchInput={searchInput}
          items={items}
          city={city}
          infoItems={infoItems}
          contactInfo={contactInfo}
          onMenuItemClick={handleMenuItemClick}
          onSearchClick={() => setShowSearch(true)}
        />
      ) : (
        <NestedScreen
          navigationHistory={navigation}
          additionalItems={additionalItems}
          onBackClick={handleBackClick}
          onMenuItemClick={handleMenuItemClick}
        />
      )}
    </div>
  );
}
